import React, {Component} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap'
import {changeProductionStatus} from "../../../services/api/apiNextBarcode"
import Button from "reactstrap/es/Button"
import Promise from 'bluebird'
import {pushNewItemHistory} from "../../../services/api/apiItemHistory";

class BulkChangeStatusModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            status: '',
            listItems: [],
            itemsSuccess: [],
            itemError: [],
            itemLoading: ''
        }
    }

    componentDidMount = async () => {
        await this._genListItems()
    }

    _genAllItems = () => {
        const {listItems} = this.state

        this._bukdChangeStatus(listItems)
    }

    _handleChangeStatus = (e) => {
        const {value} = e.target

        const r = window.confirm(`Are you sure want to do Change status to ${value}?`)

        if (r !== true) {
            this.setState({
                status: ''
            })
            return
        }

        this.setState({
            status: value
        }, () => {
            this._genAllItems()
        })
    }

    _genListItems = () => {
        const {items, selectedItems} = this.props
        const listItems = items.filter(item => selectedItems.includes(item._id))

        this.setState({
            listItems
        })
    }

    _bukdChangeStatus = async (listItems) => {
        const {status} = this.state

        const total = this.state.itemsSuccess.length > 0 ? (listItems.length + this.state.itemsSuccess.length) : listItems.length

        status !== '' && (
            await Promise.each(listItems, async item => {
                this.setState({
                    itemLoading: item._id
                })

                try {
                    const {production_status} = item
                    const {success} = await changeProductionStatus(item._id, status)
                    let {itemError, itemsSuccess} = this.state

                    if(success) {

                        itemsSuccess.push(item._id)

                        this.setState({
                            itemsSuccess: itemsSuccess,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        }, () => {
                            return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                                event_key: 'change_status',
                                event_description: `Change status on bulk actions`,
                                event_meta: {
                                    from: production_status,
                                    to: status
                                }
                            })
                        })


                    } else {
                        itemError.push({
                            _id: item._id,
                            message: 'Error'
                        })

                        this.setState({
                            itemError: itemError,
                            itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                        })
                    }
                } catch (e) {
                    let {itemError, itemsSuccess} = this.state

                    this.setState({
                        itemError: e.message,
                        itemLoading: (itemError.length + itemsSuccess.length) === total ? '' : item._id
                    })
                }

            })
        )
    }

    _changeItemStatus = async (item) => {
        const {status} = this.state

        try {
            const {production_status} = item
            const {itemsSuccess, itemError} = this.state
            const {success, message} = await changeProductionStatus(item._id, status)

            if(success) {
                itemsSuccess.push(item._id)

                this.setState({
                    itemsSuccess: itemsSuccess,
                    itemLoading: ''
                }, () => {
                    return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                        event_key: 'change_status',
                        event_description: `Change status on bulk actions`,
                        event_meta: {
                            from: production_status,
                            to: status
                        }
                    })
                })
            } else {
                const newItemErr = itemError.map(item2 => {
                    if(item2._id === item._id) {
                        return {
                            ...item2,
                            message: message
                        }
                    }
                    return item2
                })

                this.setState({
                    itemError: newItemErr,
                    itemLoading: ''
                })
            }
        } catch (e) {
            this.setState({
                itemError: e.message,
                itemLoading: ''
            })
        }
    }

    _handleClickRetryItem = async (item) => {
        const {itemError} = this.state
        const newItemsStatus = itemError.map(item2 => {
            if(item2._id === item._id) {
                return {
                    ...item2,
                    message: ''
                }
            } else {
                return item2
            }
        })

        this.setState({
            itemError: newItemsStatus,
            itemLoading: item._id
        })

        this._changeItemStatus(item)
    }

    _retryAll = () => {
        const {itemError} = this.state

        this.setState({
            itemError: []
        })

        this._bukdChangeStatus(itemError)
    }

    _showMessage = (itemError, itemsSuccess, _id) => {
        if(itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if(itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if(itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Order change status success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    render() {
        const {isOpen, handleToggleModal} = this.props
        const {listItems, itemLoading, itemsSuccess, itemError, status} = this.state

        return (
            <div>
                <Modal isOpen={isOpen} className="BulkChangeStatus"
                >
                    <ModalHeader>
                        Bulk change status
                    </ModalHeader>
                    <ModalBody>
                        <div className="selectStatus mb-3 row">
                            <label className="col-sm-3 col-form-label">Change status</label>
                            <div className="col-sm-9">
                                <select value={status} className="form-control" disabled={status !== ''} onChange={this._handleChangeStatus}>
                                    <option value="">Select Status</option>
                                    <option value="on-hold">On hold</option>
                                    <option value="cancelled">Cancelled</option>
                                    <option value="in_production">In production</option>
                                </select>
                            </div>
                        </div>
                        {status && (
                            <div className="ListChangeStatus">
                                {listItems.length > 0 && (
                                    listItems.map(item => {
                                        return (
                                            <div key={item._id} className="ItemChangeStatus d-sm-flex mb-2 pb-2">
                                                <div className="IconStatus mr-2">
                                                    {itemsSuccess.includes(item._id) && (
                                                        <i className="icon-check text-success"/>
                                                    )}
                                                    {
                                                        (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemError.find(itemErr => item._id === itemErr._id).message) && (
                                                            <i className="icon-cross text-danger"/>
                                                        )
                                                    }
                                                </div>
                                                <div className="ContentChangeStatus">
                                                    <strong>{item.orderNumber}</strong> - orderID: #{item.barcodeNumber}
                                                    {
                                                        (itemError.find(itemErr => item._id === itemErr._id) !== undefined && itemLoading !== item._id) && (
                                                            <span onClick={() => this._handleClickRetryItem(item)}>
                                                            <i className="icon-spinner11 text-danger ml-2"/>
                                                        </span>
                                                        )
                                                    }
                                                    {itemLoading === item._id && <i className='icon-spinner2 spinner ml-2'/>}
                                                    {this._showMessage(itemError, itemsSuccess, item._id)}
                                                </div>
                                            </div>
                                        )
                                    })
                                )}
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            {itemError.length > 0 && (
                                <Button onClick={this._retryAll} className="bg-danger"><i className="icon-spinner11 mr-1"/> Retry all</Button>
                            )}
                            <Button disabled={itemLoading} onClick={handleToggleModal} className="bg-primary ml-2">
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default BulkChangeStatusModal